// THE Autodesk viewer (LMV) SDK the app loads — one version, one place.
//
// PINNED, not `7.*`: the floating URL let Autodesk change loading behaviour under us without a
// deploy. 7.119 turned "Large Model Experience" on by default, which turned an Autodesk
// cache bug from a console error into a dead viewer loop (see below). Upgrade by changing this
// constant after testing a multi-model site (winery) cold and warm.
//
// Do NOT set `window.USE_OPFS = false` before the SDK loads. Doing so forces Autodesk's
// IndexedDB "hash cache", whose `_loadHashCache` dereferences a database handle it discarded
// earlier. We load models one at a time, so between models no model is active, Autodesk clears
// that cache, and the next model's first 200 meshes trip the crash — with Large Model
// Experience the exception escapes the viewer's main loop and every model after the first
// never finishes. Autodesk's default (OPFS) cache disables that code path entirely. OPFS is
// keyed by URN; every upload gets a unique object key and ACC links carry their version, so a
// changed file always has a new URN and cannot hit a stale entry.
export const LMV_SDK_VERSION = '7.126.0';

const LMV_SDK_BASE = `https://developer.api.autodesk.com/modelderivative/v2/viewers/${LMV_SDK_VERSION}`;

export const LMV_SDK_SCRIPT_URL = `${LMV_SDK_BASE}/viewer3D.min.js`;
export const LMV_SDK_STYLE_URL = `${LMV_SDK_BASE}/style.min.css`;
